import { Component, Input } from '@angular/core';
import { ExaAdapterService } from '../../services/exa-adapter.service';
import { ExaAdapterRestService } from '../../api/exa/api/exaAdapterRest.service';
import { ModalController } from '@ionic/angular';
import { MachineService } from '../../services/machine.service';

@Component({
  selector: 'app-assign-machine-dialog',
  templateUrl: './assign-machine-dialog.component.html',
  styleUrls: ['./assign-machine-dialog.component.scss'],
})
export class AssignMachineDialogComponent {
  @Input() machineName: string;
  @Input() machineId: number;

  adapters = null;
  selectedAdapter = null;
  disableAssign = false;

  constructor(
    private modalCtrl: ModalController,
    private machineService: MachineService,
    private adapterService: ExaAdapterService,
    private adapterRestService: ExaAdapterRestService
  ) {
    this.adapterService.onGetAdapters().subscribe((adap) => (this.adapters = adap));
  }

  onClickAssign() {
    console.log(this.selectedAdapter);
    // this.adapterRestService.assignToMachineByMacUsingPOST(this.selectedAdapter, this.machineId).subscribe(data => {
    //   this.disableAssign = true;
    //   this.machineService.reloadMachines();
    //   this.adapterService.reloadAdapters();
    //   this.dismiss();
    // });
  }

  selectAdapter(adapter) {
    this.selectedAdapter = adapter;
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
